import katex from 'katex';
import 'katex/contrib/mhchem';
import type { FC } from 'react';
import { useLayoutEffect, useRef } from 'react';
import './latex.css';

export const latexRender = (value: string, element?: HTMLElement | null) => {
  let errorMsg = '';
  if (!element) {
    try {
      katex.renderToString(value, {
        output: 'html',
        displayMode: true,
        throwOnError: true,
      });
    } catch (e: any) {
      errorMsg = `${e.message}`.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    return { errorMsg };
  }
  try {
    katex.render(value, element, {
      output: 'html',
      displayMode: true,
      throwOnError: true,
      strict: false,
    });
  } catch (e: any) {
    errorMsg = e?.message
      ? `${e.message}`.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      : '公式错误';
  }

  return {
    errorMsg,
  };
};

export const LatexComponent: FC<{
  className?: string;
  inline?: boolean;
  text?: string;
  onClick?: () => void;
  onRender?: (error: string) => void;
  children?: React.ReactNode;
}> = (props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { className, text = '', onClick, onRender, inline } = props;

  useLayoutEffect(() => {
    const { errorMsg } = latexRender(text, divRef.current);
    onRender?.(errorMsg);
  }, [onRender, text]);

  return (
    <span className={className} onClick={onClick}>
      {inline ? <span ref={divRef} className="inline-latex inline-block" /> : <div ref={divRef} />}
      {props.children}
    </span>
  );
};
